/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraCustomFieldMetadataSchema = z.object({
  fieldType: z.enum([
    'SELECT',
    'MULTI_SELECT',
    'DATE',
    'DATETIME',
    'TEXT',
    'MULTILINE_TEXT',
    'NUMERIC',
    'CHECKBOX',
    'MULTI_CHECKBOX',
    'USER',
    'MULTI_USER',
    'TEAM',
    'VERSION',
    'COMPONENT',
    'LABELS',
  ]),
  id: z.string(),
  isMultiValue: z.boolean(),
  name: z.string(),
  requiresOptions: z.boolean(),
  supportedOperators: z.array(
    z.enum([
      'EQUALS',
      'NOT_EQUALS',
      'CONTAINS',
      'NOT_CONTAINS',
      'GREATER_THAN',
      'GREATER_THAN_OR_EQUALS',
      'LESS_THAN',
      'LESS_THAN_OR_EQUALS',
      'BETWEEN',
      'NOT_BETWEEN',
      'IN',
      'NOT_IN',
      'IS_EMPTY',
      'IS_NOT_EMPTY',
    ]),
  ),
});
